import { z } from "zod";

// todo
// verify same task not created twice
// verify task events are not duplicated

export const taskSchema = z.object({
	id: z.string(),
	name: z.string(),
	description: z.string().optional(),
	type: z.enum([
		"custom_task",
		"birthday_task",
		"lead_followup_task",
		"prescription_order_task",
		"license_renewal_task",
	]),
	status: z.enum(["pending", "in_progress", "completed", "cancelled", "expired"]),
	createdBy: z.enum(["admin", "system"]),
	createdAt: z.number(),
	// A task with a future startAt exists in the DB but is hidden from all task
	// screens until its time arrives (e.g. prescription order tasks open one day
	// before the prescription's opening date).
	startAt: z.number().optional(),
	dueAt: z.number().optional(),
	updatedAt: z.number().optional(),
	assignTo: z.discriminatedUnion("type", [
		z.object({
			type: z.literal("admin"),
			adminId: z.string().optional(),
		}),
		z.object({
			type: z.literal("system"),
		}),
	]),
	// reference
	clientId: z.string().optional(),
	leadId: z.string().optional(),
	requestId: z.string().optional(),
});

export const newTaskSchema = taskSchema.omit({ id: true });

export type TNewTask = z.infer<typeof newTaskSchema>;
export type TTask = z.infer<typeof taskSchema>;

/** How many days before a prescription opens its order task should surface.
 *  One day left the rep no room to reach the patient, place the order and have
 *  it ready in time. Shared so the confirmation popup promises exactly what
 *  confirmPrescriptions actually schedules. */
export const PRESCRIPTION_TASK_LEAD_DAYS = 5;
